var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainLeft"},[_c('recommend',{attrs:{"data":_vm.data}}),_c('newRelease',{attrs:{"arr":_vm.data2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }